import { SpecsProvider } from '../api/SpecsContext'

import { DiscountProductPage } from './presets/discount/discount-product-page'

export const DiscountProductScreen = () => (
	<SpecsProvider>
		<DiscountProductPage />
	</SpecsProvider>
)
